import React from 'react';
import { Lock } from 'lucide-react';
import { usePremium } from '../Subscription/PremiumProvider';
import { isLocked } from '../../lib/premiumLock';
import { highlightMatch, resultItemKey } from './highlightMatch';

/**
 * Collapsed result rows in one bordered container.
 * Subtitle: "N topics" for baskets, "no basket" for standalones — no match-type labels.
 */
const ConnectionsResultRowList = ({ items, searchTerm, onExpand }) => {
  const { isPremium, isLoading } = usePremium();

  if (!items?.length) return null;

  return (
    <ul className="border-2 border-neutral-200 rounded-xl overflow-hidden bg-white divide-y divide-neutral-200">
      {items.map((item) => {
        const subtitle =
          item.kind === 'basket'
            ? `${item.topics?.length || 0} topic${(item.topics?.length || 0) === 1 ? '' : 's'}`
            : 'no basket';
        const lockedEntity =
          item.kind === 'basket' ? item : item.topic || item;
        const showLock = isLocked(lockedEntity, isPremium, isLoading);

        return (
          <li key={resultItemKey(item)} className="even:bg-neutral-50">
            <button
              type="button"
              onClick={() => onExpand(item)}
              className="w-full text-left px-4 py-3 hover:bg-neutral-100 focus:outline-none focus:bg-neutral-100 focus:ring-2 focus:ring-inset focus:ring-cranberry-700 transition-colors"
              aria-label={`Expand ${item.name}${showLock ? ' (Premium)' : ''}`}
            >
              <div className="flex items-center gap-2 min-w-0">
                <p className="font-semibold text-neutral-900 truncate min-w-0">
                  {highlightMatch(item.name, searchTerm)}
                </p>
                {showLock && (
                  <Lock
                    size={14}
                    className="text-neutral-400 shrink-0"
                    aria-hidden="true"
                  />
                )}
              </div>
              <p className="text-sm text-neutral-500 mt-0.5">{subtitle}</p>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ConnectionsResultRowList;
